var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"sidebar"},[_c('card'),_vm._v(" "),_c('list')],1),_vm._v(" "),_c('div',{staticClass:"main"},[_c('message'),_vm._v(" "),_c('textinput')],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38327a6b","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/wsmock/App.vue
// module id = 424
// module chunks = 2